<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<p-heading tag="h1" class="text-balance">
  {{ 'signup.owner.confirmation.introduction.headline' | translate }}
</p-heading>

<div class="w-full flex flex-col">
  <p-text [size]="{ base: 'sm', m: 'md' }" class="text-balance mt-fluid-md">
    {{ 'signup.owner.confirmation.introduction.subline' | translate }}
  </p-text>

  <p-heading tag="h2" size="sm" class="mt-fluid-2xl xs:mt-fluid-md order-last xs:order-0">
    {{ 'signup.owner.confirmation.introduction.advantages.label' | translate }}
  </p-heading>

  <ul class="mt-fluid-md space-y-static-sm ps-0 order-last xs:order-0">
    @for (
      advantage of [
        'signup.owner.confirmation.introduction.advantages.vehicleStatus',
        'signup.owner.confirmation.introduction.advantages.connectAccess',
        'signup.owner.confirmation.introduction.advantages.exclusive',
      ];
      track advantage
    ) {
      <li class="list-none">
        <p-text size="sm">
          <p-icon class="me-xs" name="check" aria-hidden="true" />
          <span>{{ advantage | translate }}</span>
        </p-text>
      </li>
    }
  </ul>

  <div>
    <p-button
      (click)="onContinue()"
      class="mt-fluid-lg md:mt-fluid-md w-full xs:w-auto"
      variant="primary"
      data-e2e="confirmation-introduction-submit-button"
      [myprofileSignupUiTrack]="{
        clickElementType: 'button',
        clickElementId: 'call_to_action',
        clickElementName: 'confirmation_introduction_continue',
        pageName: currentPageName,
        eventAction: currentEventAction,
      }"
    >
      {{ 'signup.owner.confirmation.introduction.button.label' | translate }}
    </p-button>
  </div>
</div>
